import React from "react";
import ExperienceCard from "./ExperienceCard";
import locateitLogo from "../images/locateitLogo.png";
import faoLogo from "../images/faoLogo.png";
import rcmrdLogo from "../images/rcmrdLogo.png";
import dkutLogo from "../images/dekutLogo.png";

export default function ExperienceListItems() {
  const experiences = [
    {
      title: "Space Applications Expert",
      duration: "January 2025 - Present",
      company: "LocateIT Ltd",
      logo: locateitLogo,
      address:
        "5th floor, Galana Plaza, Galana Road, Kilimani-Nairobi, P.O. Box 17227-00100",
      contact:
        "Tel: +254-782001200 / +254-722822125 | Email: info@locateit.co.ke",
      website: "https://locateit.co.ke",
      responsibilities: [
        "Leading the design, development, and deployment of Earth Observation (EO)-based applications for environmental monitoring and decision support.",
        "Overseeing the end-to-end implementation of geoportals, mobile apps, and QGIS plugins for projects across Africa.",
        "Coordinating interdisciplinary teams in the development of digital solutions under international programmes such as GMES & Africa, AGRI-CONNECT, and ASAL Adapts.",
        "Developing, validating, and automating geospatial data processing workflows using Python, Google Earth Engine (GEE), and machine learning models.",
        "Engaging stakeholders through technical consultations, project reviews, and capacity-building workshops across regional and national institutions.",
        "Ensuring system scalability, data quality, and seamless integration between EO-derived datasets and web-based visualization dashboards.",
        "Contributing to product innovation and digital transformation strategies within LocateIT’s Geo-ICT and Space Applications unit.",
      ],
    },

    {
      title: "GIS & Remote Sensing Analyst",
      duration: "January - December 2024",
      company: "LocateIT Ltd",
      logo: locateitLogo,
      address:
        "5th floor, Galana Plaza, Galana Road, Kilimani-Nairobi, P.O. Box 17227-00100",
      contact:
        "Tel: +254-782001200 / +254-722822125 | Email: info@locateit.co.ke",
      website: "https://locateit.co.ke",
      responsibilities: [
        "Development of Earth Observation based thematic products for coastal erosion monitoring, environmental hazards, and impact assessments.",
        "Data engineering and analysis for Monitoring and Evaluation geoportals developed by the organization.",
        "Development of geodata-based machine learning models and automation of GeoICT workflows to enhance efficiency and accuracy.",
        "Conducting online and physical trainings on applications of space technologies and EO & GIS based thematic workshops.",
      ],
    },

    {
      title: "GIS / RS / GIT Technical Support",
      duration: "September - December 2023",
      company: "LocateIT Ltd",
      logo: locateitLogo,
      address:
        "5th floor, Galana Plaza, Galana Road, Kilimani-Nairobi, P.O. Box 17227-00100",
      contact:
        "Tel: +254-782001200 / +254-722822125 | Email: info@locateit.co.ke",
      website: "https://locateit.co.ke",
      responsibilities: [
        "Development of products relating to the application of space applications and EO-based environmental data products.",
        "Design and application of Earth Observation through integrated geospatial applications including Google Earth Engine (GEE) and machine learning.",
        "Preparing concept notes and project proposals for capacity building and application of EO, GIS, GIT, and Geo-ICT technologies.",
        "Representing the company in scientific, technological, and business forums including meetings, conferences, and exhibitions.",
        "Assisting in company outreach activities such as blogging and publishing EO, GIS, and Geo-ICT content.",
        "Automation of GeoICT workflows.",
      ],
    },

    {
      title: "Urban Food Systems End-line Survey Enumerator",
      duration: "March 2023",
      company: "Food and Agriculture Organization of the United Nations (FAO)",
      logo: faoLogo,
      address:
        "Integrated Actions for Innovative Food Systems Across Rural-Urban Communities",
      contact: "",
      website:
        "https://openknowledge.fao.org/items/25a5b350-cbbe-41cd-94b0-fa3ae977873b",
      responsibilities: [
        "Conducting face-to-face interviews and recording survey responses.",
        "Attending training sessions and pretesting Kobo Collect survey forms.",
        "Reporting to remote duty stations for the entire period of engagement.",
        "Examining respondent eligibility, obtaining informed consent, and ensuring data confidentiality.",
      ],
    },

    {
      title: "Remote Sensing Intern",
      duration: "January - April 2022",
      company:
        "Regional Centre for Mapping of Resources for Development (RCMRD)",
      logo: rcmrdLogo,
      address:
        "Geospatial Services Directorate, Remote Sensing Section, Roysambu, Kasarani, P.O. Box 632-00618 Nairobi, Kenya",
      contact: "",
      website: "https://rcmrd.org",
      responsibilities: [
        "Water-related ecosystem mapping and analysis of changes in their extent.",
        "Cloud-based satellite imagery processing using Google Earth Engine and DE Africa Sandbox.",
        "Drought monitoring using EO systems for early warning and preparedness.",
        "Vegetation analysis and environmental relationship assessments.",
        "Urban extent mapping and trend analysis.",
        "Vulnerability assessment of human settlements to natural disasters including floods.",
      ],
    },

    {
      title: "Geospatial & Remote Sensing Attaché",
      duration: "January - March 2021",
      company:
        "Dedan Kimathi University of Technology – Institute of Geomatics",
      logo: dkutLogo,
      address: "P.O. Box 657-10100 Nyeri, Kenya",
      contact: "",
      website: "https://iggres.dkut.ac.ke",
      responsibilities: [
        "Acquisition and processing of satellite imagery from multiple sources and execution of geoprocessing workflows.",
        "Mapping using Unmanned Aerial Systems (UAS) including project planning, aerial surveys, data processing, and visualization.",
        "Cartographic drawing and preparation of survey plans.",
        "Development of field data collection applications and mobile mapping solutions.",
        "Creation and management of geodatabases, geoenrichment, and spatial data visualization.",
        "Advanced map generation using Esri ArcMap and QGIS.",
        "Crowdsourcing data collection and visualization using ArcGIS dashboards.",
        "Surveying tasks including traversing, leveling, and establishment of control points.",
      ],
    },
  ];

  return (
    <div className="experience-list">
      <div className="workshop-header">
        <h2>Work Experience </h2>
        <p>
          Professional experience, key responsibilities, and contributions
          across roles and organizations.
        </p>
      </div>
      {experiences.map((exp, index) => (
        <ExperienceCard key={index} {...exp} />
      ))}
    </div>
  );
}
